import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS } from '../constants/constants';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getUser(id: number): Observable<Object> {
    return this.http.get(`${CONSTANTS.BASE_API}users/${id}`);
  }

  getUsers(): Observable<Object> {
    return this.http.get(`${CONSTANTS.BASE_API}users`);
  }

  updateUser(id: number, user: any): Observable<Object> {
    return this.http.patch(`${CONSTANTS.BASE_API}users/${id}`, user);
  }

  saveUserSetting(setting: string, value: any): Observable<Object> {
    const http = this.http.post(
      `${CONSTANTS.BASE_API}users/${this.authService.user?.id}/settings`,
      {
        setting,
        value,
      }
    );

    http.subscribe(() => {
      this.authService.updateSetting(setting, value);
    });

    return http;
  }
}
